import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { SelectionDescription } from '../utils/selectionLabel';

const I18N_BASE = 'scenes.visit_history.selection';

interface VisitSelectionChipProps {
  description: SelectionDescription | null;
  onClear: () => void;
}

/** The active selection ("Camioneta: X"), with a way to clear it. */
function VisitSelectionChip({ description, onClear }: VisitSelectionChipProps) {
  const { t } = useTranslation();

  if (!description) return null;

  return (
    <div className="visit-history-selection">
      <span className="visit-history-selection__chip">
        {t(`${I18N_BASE}.kinds.${description.kind}`)}:{' '}
        <b>{description.label}</b>
        <button
          type="button"
          onClick={onClear}
          aria-label={t(`${I18N_BASE}.clear`)}
        >
          <CloseOutlined />
        </button>
      </span>
      <span className="visit-history-selection__hint">
        {t(`${I18N_BASE}.hint`)}
      </span>
    </div>
  );
}

export default VisitSelectionChip;
